import { Observable, shareReplay } from 'rxjs';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { map } from 'rxjs/operators';
import {
  AysVirtualClinicP21Import,
  type AysVirtualClinicP21ImportResponse,
} from '@bindoc-projects/virtual-clinic-domain-lib';
import { KostDataImportProcessDataDe } from '../import-process';
import { KostDataImportDeApi } from './kost.store';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KostDataImportDeService {
  private readonly _environmentService = inject(BdAppEnvironmentService);
  private readonly _httpClient = inject(HttpClient);

  private readonly _api: KostDataImportDeApi;

  constructor() {
    this._api = new KostDataImportDeApi(
      this._environmentService.load(
        'AYS_VIRTUAL_CLINIC_P21_IMPORT_RESOURCE_URL',
      ),
    );
  }

  public findAll(): Observable<AysVirtualClinicP21Import[]> {
    const url = this._api.index();

    return this._httpClient
      .get<AysVirtualClinicP21ImportResponse[]>(url)
      .pipe(
        map((data) =>
          data.map((obj) => AysVirtualClinicP21Import.fromObj(obj)),
        ),
      );
  }

  public findById(
    virtualClinicReferralId: string,
  ): Observable<AysVirtualClinicP21Import> {
    const url = this._api.byId(virtualClinicReferralId);

    return this._httpClient.get<AysVirtualClinicP21ImportResponse>(url).pipe(
      map((obj) => AysVirtualClinicP21Import.fromObj(obj)),
      shareReplay(1),
    );
  }

  /** Reports upload progress; the last event is the response with the created import. */
  create(
    processData: KostDataImportProcessDataDe,
  ): Observable<HttpEvent<AysVirtualClinicP21Import>> {
    const url = this._api.index();
    const formData: FormData = new FormData();
    let queryParams = new HttpParams();

    queryParams = queryParams.set(
      'virtualClinicId',
      processData.virtualClinicId,
    );
    queryParams = queryParams.set(
      'fabSelectionStrategy',
      processData.parameters.data.fabSelectionStrategy,
    );
    queryParams = queryParams.set(
      'fabCreationStrategy',
      processData.parameters.data.fabCreationStrategy,
    );

    formData.append(
      'file',
      processData.data.output.transformed,
      processData.data.input.name,
    );

    return this._httpClient.post<AysVirtualClinicP21Import>(url, formData, {
      params: queryParams,
      observe: 'events',
      reportProgress: true,
    });
  }
}
